import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { checkAccess, ids } from '../../../../helpers/rolAccess';
import { paths } from '../../../../config/routes';
import { loadTabs } from '../../../Header/actions';
import Autoasignadas from './Autoasignadas/view';

class ContactCenter extends React.PureComponent {
  componentDidUpdate = (prevProps) => {
    this.loadTabs();
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root));
    }
  };

  loadTabs = () => {
    const tabs = [];
    if (checkAccess(ids.contactCenter, this.props.userAccessIds))
      tabs.push({ text: 'Empresas Autoasignadas', contentId: 0 });

    this.props.dispatch(
      loadTabs('Rol Contact Center', '', tabs, tabs.length ? tabs[0].contentId : null),
    );
  };

  renderBody = () => {
    switch (this.props.selectedTab) {
      case 0: {
        return <Autoasignadas />;
      }
      default:
        return <div />;
    }
  };
  render() {
    return <div style={{ paddingBottom: 60 }}>{this.renderBody()}</div>;
  }
}

const mapStateToProps = (state) => ({
  UserInfo: state.global.userData,
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactCenter);
